export const SIDEBAR_WIDTH = 300
export const TAB_MIN_WIDTH = 540
export const RECIPE_BANNER_HEIGHT = 120
export const NAV_HEIGHT = 30